export default __webpack_public_path__ + "static/media/emptyState_ConnectionAPIError.7f12b771.svg";